<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">活動</div>
            <div class="breadcrumb-item">活動列表-修改</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>活動名稱</span>
                                        </div>
                                        <Input v-model="form.title" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style2" @click="handleCheckForm">修改</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                    <!-- <Button type="error" :loading="true" class="loading-btn">
                                         <span>Loading...</span>
                                     </Button>-->
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                isSubmiting: false,
                form: {
                    title: '',
                }
            };
        },
        mounted() {
            this.pageParam = this.$route.query;
            if(this.pageParam.id == undefined) {
                this.pageParam.id = 0;
            }
            this.getDetail();
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },
            getDetail() {
                this.isSubmiting = true;
                if(this.pageParam.id != undefined) {
                    this.$Rq.requestAuth({
                        url: this.$Api.eventActivityList,
                        method: 'get',
                        data: {
                          id: this.pageParam.id
                        }
                    }).then((res) => {
                      this.isSubmiting = false;
                        if (res.code == 0) {
                          let resData = res.data[0];
                          this.form = {
                            title: resData.title,
                          };
                        }
                    });
                }
            },
            handleCheckForm()
            {
                let form = this.form;
                if (form.title === '')
                {
                    this.$Utils.showTipInfo('請輸活動名稱');
                    return;
                }  
                this.handleSubmit();
            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.eventActivityEdit + '/' + this.pageParam.id,
                    method: 'post',
                    data: {
                        name: form.title,
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                        this.getDetail();
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "eventListEdit.scss";
</style>